import { useEffect, useState, useRef, useMemo } from "react";
import { toast } from "react-toastify";
import { http } from "../auth";
import { Row, Col, Form, Button, InputGroup, Modal, Spinner } from "react-bootstrap";
import { MdHistoryEdu } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import Reporte2 from "./Reporte2";

const Reporte1 = ({ transferencia, setTransferencia, id_doc, id_servicio, factura, pasoActual, selectedCurrency, setSelectedCurrency,
  setPasoActual, loadResume, totalAPagar, totalAPagarLoading, onBankChange }) => {
  const [datosBancarios, setDatosBancarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);


  useEffect(() => {
    localStorage.setItem("selectedCurrency", selectedCurrency);
  }, [selectedCurrency]);

  const fetchDataBanco = async () => {
    setLoading(true);
    try {
      let response = await http.get(`/config/intranet_config_residencial/datos_bancarios`);
      setDatosBancarios(response.data);
      setLoading(false);
    } catch (error) {
      if (![200, 401].includes(error?.response?.status)) {
        toast.error("Ocurrio un error al cargar los bancos");
      }
    }
  };

  useEffect(() => {
    fetchDataBanco();
  }, []);

  const BancosEnabledR = datosBancarios?.bs?.bancos?.some((banco) => banco.enabled_r === true);
  const BancosEnabledRUsd = datosBancarios?.usd?.some((banco) => banco.enabled_r === true);

  useEffect(() => {
    if (!BancosEnabledRUsd) {
      setSelectedCurrency("bs");
    } else {
      setSelectedCurrency("usd");
    }
  }, [datosBancarios]);

  const handleDivClick = () => {
    setIsChecked((prevState) => !prevState);
  };

  const handleContinue = () => {
    setPasoActual(2);
    setTransferencia(!transferencia);
    onHidden();
  };

  const onHidden = () => {
    setShowModal(false);
  };

  const modalContent = useMemo(
    () => (
      <Modal centered size="md" show={showModal} onHide={onHidden}>
        <div className="d-flex justify-content-end align-items-center p-4">
          <RxCross2 onClick={onHidden} className="close-icon" />
        </div>
        <Modal.Body className="text-center modal-terms p-5">
          <div className="mb-3">
            <MdHistoryEdu className="icon-terms" />
          </div>
          <span className="confirmation">
            Recuerde que los pagos realizados y reportados vía transferencia bancaria pueden{" "}
            <span className="attention">demorar hasta 48 horas hábiles para ser liquidados</span>
          </span>
          <div className="mt-4 terms" onClick={handleDivClick}>
            <input className="me-2 check-terms" name="terminos" type="checkbox" id="1" checked={isChecked} readOnly />
            <span>Acepto los términos y condiciones establecidos</span>
          </div>
          <Button
            className={`btn-continue ${isChecked ? "btn-primary" : "btn-secondary"}`}
            onClick={handleContinue}
            disabled={!isChecked}
          >
            Continuar
          </Button>
        </Modal.Body>
      </Modal>
    ),
    [showModal, isChecked],
  );

  return (
    <div>
      {modalContent}
      {pasoActual === 1 && (
        <div>
          <h3 className="titulo-report mt-3">Reporte de pagos</h3>
          <span className="steps">Paso 1 de 2</span>
          <div className="form-pago border-card mt-2 p-3">
            <span className="subtile-pago">Moneda con la que desea pagar</span>
            <div className="currency-selector">
              <div
                style={{
                  cursor: !loadResume ? "" : "pointer",
                  opacity: !loadResume ? 0.6 : 1  
                }}
                onClick={() => loadResume && setSelectedCurrency("usd")}
              >
                <InputGroup className="mb-3 custom-group">
                  <InputGroup.Text className="border-select check-dolar">
                    <Form.Check
                      className="current-radio"
                      type="radio"
                      name="currencyOption"
                      onChange={() => loadResume && setSelectedCurrency("usd")}
                      checked={selectedCurrency === "usd"}
                      disabled={!loadResume}
                    />
                    <label className="ms-1 ms-sm-3 me-sm-2 currency-label" htmlFor="">
                      USD
                    </label>
                  </InputGroup.Text>
                  <InputGroup.Text className="symbol-coin border-select" id="basic-addon2">
                    $
                  </InputGroup.Text>
                </InputGroup>
              </div>
              <div
                style={{
                  cursor: !loadResume ? "" : "pointer",
                  opacity: !loadResume ? 0.6 : 1  
                }}
                onClick={() => loadResume && setSelectedCurrency("bs")}
              >
                <InputGroup className="mb-3 custom-group">
                  <InputGroup.Text className="border-select check-bolivar">
                    <Form.Check
                      className="current-radio"
                      type="radio"
                      name="currencyOption"
                      onChange={() => loadResume && setSelectedCurrency("bs")}
                      checked={selectedCurrency === "bs"}
                      disabled={!loadResume}
                    />
                    <label className="ms-1 ms-sm-3 me-sm-2 currency-label" htmlFor="">
                      Bolívares
                    </label>
                  </InputGroup.Text>
                  <InputGroup.Text className="symbol-coin border-select" id="basic-addon2">
                    Bs.
                  </InputGroup.Text>
                </InputGroup>
              </div>
            </div>


            <span className="subtile-pago">Datos del pago</span>
            <div className="bank-data">
              {loading ? (
                <div className="placeholder-glow">
                  <div className="d-flex flex-row mb-3 gap-4">
                    <div className="placeholder rounded" style={{ width: 60, height: 60 }}></div>
                    <div className="flex-grow-1">
                      <div className="placeholder col-5 mb-2" style={{ height: 16 }}></div>
                      <div className="placeholder col-8 mb-1" style={{ height: 12 }}></div>
                      <div className="placeholder col-6 mb-1" style={{ height: 12 }}></div>
                    </div>
                  </div>
                  <div className="d-flex flex-row mb-3 gap-4">
                    <div className="placeholder rounded" style={{ width: 60, height: 60 }}></div>
                    <div className="flex-grow-1">
                      <div className="placeholder col-5 mb-2" style={{ height: 16 }}></div>
                      <div className="placeholder col-8 mb-1" style={{ height: 12 }}></div>
                      <div className="placeholder col-6 mb-1" style={{ height: 12 }}></div>
                    </div>
                  </div>
                  <div className="d-flex flex-row gap-4">
                    <div className="placeholder rounded" style={{ width: 60, height: 60 }}></div>
                    <div className="flex-grow-1">
                      <div className="placeholder col-5 mb-2" style={{ height: 16 }}></div>
                      <div className="placeholder col-8 mb-1" style={{ height: 12 }}></div>
                      <div className="placeholder col-6 mb-1" style={{ height: 12 }}></div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {!BancosEnabledR && !BancosEnabledRUsd && (
                    <Col xs={12}>
                      <h4 className="text-center">
                        <strong>No hay medios de pagos disponibles</strong>
                      </h4>
                    </Col>
                  )}
                  {BancosEnabledRUsd && selectedCurrency === "usd" && (
                    <div>
                      <Col xs={12} className="mt-2 mb-2 pago-color">
                        <div>
                          <div className="d-flex flex-column">
                            {datosBancarios?.usd
                              ?.filter((el) => el.enabled_r)
                              .map((el, index) => (
                                <div className="d-flex flex-row mb-3 gap-4" key={index}>
                                  <div>
                                    <img src={el?.image} className="logo-details" />
                                  </div>
                                  <div>
                                    <h5>{el?.nombre}</h5>
                                    {el?.titular && <p className="mb-0">Titular: {el?.titular}</p>}
                                    {el?.account_number && <p className="mb-0">Account Number: {el?.account_number}</p>}
                                    {el?.routing_number && (
                                      <p className=" mb-0">Routing Number: {el?.routing_number}</p>
                                    )}
                                    {el?.direccion && <p className=" mb-0">Dirección: {el?.direccion}</p>}
                                    {el["FEI/EIN"] && <p className="mb-0">FEI/EIN: {el["FEI/EIN"]}</p>}
                                    {el?.correo && <p className="mb-0">Correo: {el?.correo}</p>}
                                    {el?.moneda && <p className=" mb-0">{el?.moneda}</p>}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </Col>
                    </div>
                  )}
                  {BancosEnabledR && selectedCurrency === "bs" && datosBancarios && (
                    <div>
                      <Col xs={12} className="mt-2 mb-2">
                        <div className="pago-color">
                          <div className="d-flex flex-column">
                            {/* Encabezado */}
                            {datosBancarios?.bs?.encabezado && (
                              <div className="d-flex flex-row mb-3 ms-4">
                                <div>
                                  <h5 className="ms-3">TRANSFERENCIA NACIONAL</h5>
                                  <p className="ms-3 mb-0">
                                    Razón social: {datosBancarios?.bs.encabezado?.razon_social}
                                  </p>
                                  <p className="ms-3 mb-0">RIF: {datosBancarios?.bs.encabezado?.RIF}</p>
                                  <p className="ms-3 mb-0">Correo: {datosBancarios?.bs?.encabezado?.correo}</p>
                                </div>
                              </div>
                            )}
                            {/* Lista de bancos filtrada */}
                            {datosBancarios?.bs?.bancos
                              .filter((el) => el.enabled_r)
                              .map((el, index) => (
                                <div className="d-flex flex-row mb-3" key={index}>
                                  <div>
                                    <img src={el?.image} className="logo-details" />
                                  </div>
                                  <div>
                                    <h5 className="ms-3">{el?.nombre_banco}</h5>
                                    <p className="ms-3 mb-0">{el?.tipo_cuenta?.toUpperCase()}</p>
                                    <p className="ms-3 mb-0">{el?.numero_cuenta}</p>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </Col>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {(BancosEnabledR || BancosEnabledRUsd) && (
            <Button className="mt-3" style={{ width: "100%" }} onClick={() => setShowModal(true)}>
              Siguiente
            </Button>
          )}
        </div>
      )}
      {pasoActual === 2 && (
        <Reporte2 currency={selectedCurrency} id_doc={id_doc} id_servicio={id_servicio} factura={factura} totalAPagar={totalAPagar} onBankChange={onBankChange} />
      )}
    </div>
  );
};

export default Reporte1;
